import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  error: {
    color: red.A400,
  },
  disabledButton: {
    color: 'grey',
  },
});

export default useStyles;
